var exports = {
  "Qq": "xfd349460--a527f5--text",
  "X0": "xfd349460--a527f5--formatted",
};

module.exports = exports;
